module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Freight Quotation")])])], 1), _vm._v(" "), ((_vm.checkModule.indexOf('FF') >= 0)) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h5', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Existing FF Quotation")])]), _vm._v(" "), (_vm.hideButtn == false) ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px pull-right",
    on: {
      "click": _vm.openFF
    }
  }, [_vm._v("New FF Quotation")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("FF Quotation No.")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (index == 0 ? 'color:green' : 'color:red'),
      on: {
        "click": function($event) {
          _vm.editFF(item1.mainffId)
        }
      }
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                  " + _vm._s(item1.mainFFSeries) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Till :")]), _vm._v("\n                  " + _vm._s(item1.quotationTill == '1' ? 'Handover' : 'Sailing') + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(item1.ffvalidityDate)) + "\n                  "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.ffExpireStatus == 1 ? " (Expired)" : ""))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                  " + _vm._s(item1.ffStatusManager == '0' ? 'Pending' : item1.ffStatusManager == '1' ? 'Approved' : 'Rejected') + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                  " + _vm._s(item1.ffClientStatus == '0' ? 'Pending' : item1.ffClientStatus == '1' ? 'Approved' : 'Rejected') + "\n                ")]), _vm._v(" "), (index == '0' && item1.ffClientStatus != '2' && item1.ffClientStatus != '1') ? _c('td', [(item1.ffStatusManager != '1' && item1.sendHODApproveFF == '1') ? _c('b', [_vm._v("Sent For Approval\n                    "), _c('br')]) : (item1.ffStatusManager == '1' && item1.sendToEnquiryFF == '0') ? _c('b', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.openPop(item1)
        }
      }
    }, [_vm._v("Send To Enquiry Team\n                    "), _c('br')]) : (item1.ffStatusManager == '1' && item1.sendToEnquiryFF == '1') ? _c('b', [_vm._v("Already Sent to Enquiry\n                    "), _c('br')]) : _c('b', [_vm._v("N/A\n                    "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                    " + _vm._s(item1.ffClientStatus == '2' && index == 0 ? "Client Rejected" : item1.ffClientStatus == '1' && index == 0 ? "Client Approved" : "N/A") + "\n                    "), _c('br')])]), _vm._v(" "), _c('td', [(item1.ffQuotationPdf != '' && item1.ffQuotationPdf != null) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.ffQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  })], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3349f7fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewMainEnqQuotationFF.vue
// module id = 2510
// module chunks = 0